<h1 mat-dialog-title>

    <b>Pagar Préstamo</b></h1>
<br/>
<form #pagoPrestamoForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Solicitado </mat-label>

                <mat-option> {{data.montoSolicitado}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cuota a pagar </mat-label>
                <mat-option> {{data.numCuota}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cantidad Cuotas </mat-label>
                <mat-option> {{data.idCantidadCuota}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Cuota </mat-label>
                <mat-option> {{data.totalCuota}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Interés (1,3%) </mat-label>
                <mat-option>{{data.tasaInteres}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Total Cuota </mat-label>
                <mat-option> {{data.montoTotalCuota}} </mat-option>

            </form-field>
        </p>

        <p *ngIf="this.data.mostrarPago == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="pagoPrestamo.archivoTest" type="file" class="form-control-file" name="archivo" (change)="seleccionaArchivo($event,1)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>

            </form-field>

        </p>

    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div *ngIf="this.data.mostrarPago == true">
        <button mat-button class="mat-raised-button btn-success" (click)="onAgregarPagoClick(pagoPrestamoForm)">
            <i class ="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick(data.idPrestamo)">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <div *ngIf="this.data.mostrarPago == false">
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick(this.data.idPrestamo)">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>

<br/>